import React from "react"
export default function ClientDetails({
  clientName,
  clientAddress,
  clientPhone,
}) {
  return (
    <>
      <section className="my-10">
        <h2 className="text-xl uppercase font-bold mb-1">
          
          {clientName
            .split(",")
            .map((name, index) =>
            <React.Fragment key={index}>
              
                <span key={index} className="text-md font-bold mb-1">- {name}<br /></span>
              
              </React.Fragment>
            )}
            
        </h2>

        <p>{clientPhone}</p>
        <p>{clientAddress}</p>
      </section>
    </>
  );
}
